<template>
  <CRow>
    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-library" />
          <h5 class="d-inline ml-2">Merchandise Orders</h5>
          <div class="card-header-actions">
            <CButton color="primary" :to="{ name: 'Add Merchandise Order'}">
              <CIcon name="cil-plus" class="align-bottom" /><strong>Add </strong> Merchandise Orders
            </CButton>
          </div>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "MerchandiseOrders",
  components: {
    BackendTable,
  }
};
</script>
